import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import List from "./list";
import AddEdit from "./addEdit";
import getUserService from "../../../services/getUserService";

const Users = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [user, setUser] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [filterVal, setFilterVal] = useState({
    pageNumber: 1,
    pageSize: 10,
    searchText: "",
    id: "",
    totalPages: 1,
  });
  const { searchText, pageNumber, pageSize } = filterVal;
  const fetchUser = async () => {
    try {
      const list = await getUserService.GetUserListPage(filterVal);
      setFilterVal({ ...filterVal, totalPages: list.totalPages });
      setUser(list?.users || []); // Set the data to state currentPage
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchUser(); // Call fetchData initially when the component mounts
  }, [searchText, pageNumber, pageSize]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterVal((prev) => ({ ...prev, searchText: searchTerm }));
    }, 400); // ✅ Wait 400ms before making an API call

    return () => clearTimeout(delayDebounce); // ✅ Clear timeout if user keeps typing
  }, [searchTerm]); // ✅ Runs only when searchTerm changes

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleClickOpenAddDialog = () => {
    setOpenAddDialog(true);
  };
  return (
    <div>
      <h3 style={{ margin: "10px" }}>User List</h3>
      <div className="my-3 d-flex justify-content-between">
        <FormControl
          sx={{ m: 1, width: "25ch" }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Search By Email
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            name="search"
            value={filterVal.search}
            onChange={handleSearchChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            label="search"
          />
        </FormControl>
        <FormControl
          sx={{ m: 2, width: "15ch" }}
          variant="outlined"
          size="small"
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClickOpenAddDialog}
          >
            + Add User
          </Button>
        </FormControl>
      </div>
      <List
        user={user}
        fetchUser={fetchUser}
        filterVal={filterVal}
        setFilterVal={setFilterVal}
        handleClickOpenAddDialog={handleClickOpenAddDialog}
        setSelectedUser={setSelectedUser}
      />

      <AddEdit
        setOpenAddDialog={setOpenAddDialog}
        openAddDialog={openAddDialog}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        fetchUser={fetchUser}
      />
    </div>
  );
};

export default Users;
